export default class Breadcrumb {
    constructor() {
        this.fetchDomElements();
        this.initBreadCrumbListener();
    }

    fetchDomElements() {
        this.domElements = {
            rootlineContainerWrap: document.querySelectorAll('.rootlineContainerWrap')[0],
            breadcrumbs: document.querySelectorAll('.rootlineEntry a'),
            tabSwitchLinks: document.querySelectorAll('.rootlineContainerWrap .tabSwitchLinks a'),
            oldHeight: '33px',
        };
    }

    initBreadCrumbListener() {
        this.domElements.breadcrumbs.forEach((crumb) => {
            crumb.addEventListener('click', (e) => this.onCrumbClick(e));
        });

        const myObserver = new ResizeObserver(entries => {
            entries.forEach(entry => {
                if (this.domElements.oldHeight != entry.contentRect.height) {
                    this.domElements.oldHeight = entry.contentRect.height;
                    this.changedBreadCrumbHeight(this.domElements.oldHeight);
                }
            });
        });
        let target = this.domElements.rootlineContainerWrap.children[0];
        myObserver.observe(target);

        this.domElements.tabSwitchLinks.forEach((link) => {
            link.addEventListener('click', (e) => this.onTabSwitchLinkClick(e));
        });
    }

    changedBreadCrumbHeight(height) {
        let root = document.documentElement;
        root.style.setProperty('--breadcrumb-height', height + "px");
    }

    onTabSwitchLinkClick(e) {
        // Only if the link points to the current page.
        // So, we don't do anything, if we are on a news detail page.
        if (window.location.pathname == e.target.pathname) {
            e.preventDefault();

            let tabName = e.target.hash.substr(1);
            window.newsTabs.openTabAndScrollToTabs(tabName);
        }
    }

    onCrumbClick(e) {
        e.preventDefault();

        let instantDisapear = [];
        this.domElements.rootlineContainerWrap.querySelectorAll('.rootlineEntry a').forEach((el) => {
            if (e.target != el) {
                el.parentNode.classList.remove('open');
            }
        });
        this.domElements.rootlineContainerWrap.querySelectorAll('.level1').forEach((el) => {
            if (e.target.parentNode.nextSibling != el) {
                el.classList.remove('open');
                el.style.maxHeight = '0px';
                instantDisapear.push(el);
            }
        });

        let height = 0;

        let parentNode = e.target.parentNode;
        let parentNextSibling = parentNode.nextSibling;

        if (parentNode.classList.contains('open')) {
            parentNode.classList.remove('open')
            parentNextSibling.classList.remove('open');
            parentNextSibling.style.maxHeight = '0px';
        } else {
            parentNode.classList.add('open')
            parentNextSibling.classList.add('open');

            parentNextSibling.style.transition = 'max-height 0s ease 0s';
            parentNextSibling.style.maxHeight = '9999px';

            height = parentNextSibling.clientHeight;

            parentNextSibling.style.maxHeight = '0px';

            setTimeout(function() {
                parentNextSibling.style = '';
                parentNextSibling.style.maxHeight = '100%';//height+'px';
            }, 1);

            if (instantDisapear.length > 0) {
                for (let i = 0; i < instantDisapear.length; i++) {
                    instantDisapear[i].style.display = 'none';
                    setTimeout(function() {
                        instantDisapear[i].style.display = 'block';
                    }, 400);
                }
            }
        }
        this.domElements.rootlineContainerWrap.style.paddingBottom = (height + 60) + 'px';
    }
}
